import { makeStyles } from '@material-ui/core/styles'

const useVideoDropZoneStyles = makeStyles(theme => ({
   dropZoneArea: {
      border: '1px solid #8A8FAB',
      borderRadius: 5,
      minHeight: '250px',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      paddingTop: 35
   },
   topBox: {
      position: 'absolute',
      left: 20,
      '& span': { color: '#3264DC', fontWeight: 600 },
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      '&:hover': {
         cursor: 'pointer'
      }
   },
   uploadIcon: {
      backgroundColor: '#F4F7FE',
      color: '#43496A',
      width: '100px',
      height: '100px',
      marginBottom: '20px',
      '&:hover': {
         cursor: 'pointer'
      }
   },
   closeIcon: {
      marginRight: 5,
      marginTop: -1,
      color: '#B1B5C8'
   },
   videoList: {
      backgroundColor: '#F5F7FD',
      border: '1px solid #8A8FAB',
      borderRadius: 5,
      minHeight: '250px',
      justifyContent: 'flex-start',
      alignContent: 'center',
      alignItems: 'flex-start',
      paddingTop: 20,
      paddingLeft: 30,
      paddingRight: 30
   },
   cardVideo: {
      maxWidth: 260,
      marginLeft: 10,
      marginBottom: 10,
      maxHeight: 300,
      minHeight: 300
   },
   cardMedia: {
      height: 110
   },
   deleteIconButton: {
      width: '30px',
      height: '30px',
      backgroundColor: '#F4F7FE',
      color: '#43496A',
      '&:hover': {
         cursor: 'pointer'
      }
   },
   deleteIcon: {
      fontSize: 22,
      color: '#B1B5C8'
   },
   modalContainer: {
      backgroundColor: '#F9FAFC',
      width: '45%',
      right: 0,
      float: 'right',
      position: 'absolute',
      borderRadius: 0
   },
   modalContent: {
      backgroundColor: '#F9FAFC',
      height: '100vh',
      borderRadius: 0
   },
   addVideoButton: {
      width: '100px',
      height: '100px',
      boxShadow: '2px 11px 6px -5px rgba(0,0,0,0.39)',
      marginTop: 32,
      marginBottom: 15,
      backgroundColor: 'white'
   },
   addVideoContainer: {
      '&:hover': {
         color: '#3264DC',
         '& button': {
            '& span': {
               color: '#3264DC'
            }
         }
      }
   },
   addVideoIcon: {
      fontSize: 50,
      fontWeight: 100
   },
   dropZoneAreaModal: {
      paddingTop: '45%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      textAlign: 'center',
      paddingLeft: 30,
      paddingRight: 30
   },
   topBoxModal: {
      position: 'absolute',
      left: 20,
      top: '20px',
      '& span': { color: '#3264DC', fontWeight: 600 },
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      '&:hover': {
         cursor: 'pointer'
      }
   },
   uploadIconModal: {
      backgroundColor: '#FFFFFF',
      color: '#43496A',
      width: '150px',
      height: '150px',
      marginBottom: '20px',
      '&:hover': {
         cursor: 'pointer'
      }
   },
   modal: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0,0,0,.5)',
      zIndex: 10000,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
   },
   paper: {
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #cecece',
      borderRadius: '4px',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 1, 3),
      maxWidth: '550px'
   },
   confirmModalContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '1.6rem 3rem',
      gap: '1rem',
      paddingBottom: '5rem'
   },
   iconContainer: {
      alignSelf: 'center',
      marginBottom: 16
   },
   warningIcon: {
      color: '#fe6320',
      fontSize: 68
   },
   containerVideoItem: {
      display: 'flex',
      justifyContent: 'center'
   }
}))

export default useVideoDropZoneStyles
